export class Const {
	static CONTENT_WIDTH = 1920;
	static CONTENT_HEIGHT = 1200;

	static BT_01_NUM = '01';
	static BT_01_TEXT = 'About';
	static BT_01_LINK = 'https://www.google.co.jp/';
	static BT_01_TARGET = 'blank';

	static BT_02_NUM = '02';
	static BT_02_TEXT = 'Masataka Sakano';
	static BT_02_LINK = 'https://www.yahoo.co.jp/';
	static BT_02_TARGET = 'blank';

	static BT_03_NUM = '03';
	static BT_03_TEXT = 'Project';
	static BT_03_LINK = 'http://www.zaft.co.jp/';
	static BT_03_TARGET = 'self';

	static BT_04_NUM = '04';
	static BT_04_TEXT = 'Topics';
	static BT_04_LINK = 'https://tenki.jp/';
	static BT_04_TARGET = 'blank';

	static BT_05_NUM = '05';
	static BT_05_TEXT = 'News';
	static BT_05_LINK = 'https://www.jpx.co.jp/';
	static BT_05_TARGET = 'blank';
}